<template>
  <div class="row" :class="errorClass" v-if="displayField">
    <div class="col-md-4 col-lg-4 col-xl-3">
      <label class="h6 text-md-right">
        <span v-html="label"></span> <br>
        <small class="text-black-50">{{labelSecondary}}</small>
      </label>
    </div>
    <div class="col-md-8 col-lg-8 col-xl-9">
      <select v-model="selected" @change="getHgh5Cards($event)" ref="ecards">
        <option class="list-group-item" v-for="info in behaviours" :value="info.id" v-bind:key="info.id"> 
          {{ info.name }}
        </option>
      </select>
      <vue-select-image :dataImages="dataImages" :selectedImages="initialSelected" @onselectimage="onSelectImage($event)" h="250px"></vue-select-image>
      <div v-if="errorClass !== ''" class="alert alert-danger mt-1" role="alert">
        Please select behaviour Card
      </div>
    </div> 
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import VueSelectImage from 'vue-select-image'
require('vue-select-image/dist/vue-select-image.css')
import axios from 'axios'
export default {
  props: [
    'label',
    'labelSecondary',
    'isRequired',
    'displayField',
    'errorClass',
    'categoryBigcards',
    'dataImages',
    'initialSelected',
    'parentCategoryselected'
  ],
  data () {
    return {
      behaviours:null,
      behavioursChild:null,
      parentcategory:null,
      selected: ''
    }
  },
  components: {
    VueSelectImage
  },
  created () {
    console.log(' created ')
    var self = this
    console.log(' FieldHigh5CardsLoaded categoryBigcards', self.categoryBigcards)
    console.log(' FieldHigh5CardsLoaded parentCategoryselected', self.parentCategoryselected)
    console.log(' FieldHigh5CardsLoaded dataImages', self.dataImages)
    console.log(' FieldHigh5CardsLoaded initialSelected 57', self.initialSelected)
    self.parentcategory = self.categoryBigcards[0]

    WordpressRestAPI.getViewContent('bigups_ecards?parent=0')
    .then(function (response) {
      self.behaviours = response.data
      
      if (self.categoryBigcards && self.categoryBigcards.length === 2) {
        self.parentcategory = self.categoryBigcards[0]
        self.selected = self.parentCategoryselected
        console.log('56 this.selected ', self.selected, self.categoryBigcards)
        const event = { target: { value: self.selected } }
        console.log('58 before high5 called', self.behaviours)
        self.getHgh5Cards(event)
        self.onSelectImage(self.dataImages)
      }
    })
    .catch(function (e) {
      console.error(e)
    })
    console.log('  self.parentcategory ', self.parentcategory)
  },
  methods: {
   getHgh5Cards(elem, target = 'elem') {
    var self = this
    console.log(' target ', target, self.selected)
    if (target === 'refs') {
      self.parentcategory = elem[0].value
    } else {
      self.parentcategory = elem.target.value
    }
    console.log(' self.parentcategory ', self.parentcategory)
     WordpressRestAPI.getViewContent('bigups_ecards?parent=' + self.parentcategory)
      .then(function (response) {
        self.behavioursChild = response.data
        console.log('103 behavioursChild', self.behavioursChild)
        self.dataImages = []
        for (var i = 0; i < self.behavioursChild.length; i++) {
          self.dataImages.push({id: self.behavioursChild[i].id, src: self.behavioursChild[i].cover_image, alt: self.behavioursChild[i].name})
        }
        console.log('91 self.dataImages ', self.dataImages)
        /*if (self.categoryBigcards[0] && self.categoryBigcards[0] !== '') {
          self.dataImages.forEach(record => {
              console.log(' record ', record)
              if (record.id === self.categoryBigcards[1]) {
                console.log(' 96 ', record.id)
                //self.onSelectImage(self.initialSelected)
              }
          })
          //self.categoryBigcards[0] = ''
        }*/
      })
      .catch(function (e) {
        console.error(e)
      })
    },
    onSelectImage(dataImages) {
      console.log('58 before high5 called', this.behaviours)
      console.log(' dataImages ', dataImages, this.parentcategory)
      console.log(' selectedBehaviour ', this.behaviours, this.label, this.displayField)
      this.$emit('selectedBehaviour', {label: this.label, content: dataImages.id, validated: true, category: 'high5', parentcategory: this.parentcategory, displayField: this.displayField, parentName: this.behaviours.filter(x => x.id == this.parentcategory)[0].name})  
    },
    changeUser(value) {
      this.info.id = value;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/field1.vue